import UserStructure from "../Constants/UserProfileAdmirerStructure"; // Adjust the path as needed

export const fetchUserFriendMockData = async (profileId) => {
  try {
    const response = await fetch(
      `/api/mock/UserProfile/UserProfileAdmirerMockdata-${profileId.toLowerCase()}.json`
    );

    if (!response.ok) {
      throw new Error(`User data file not found`);
    }

    const data = await response.json();

    const formattedData = {
      ...UserStructure,

      userId: data.userId || "",
      name: {
        first: data.name?.first || "",
        middle: data.name?.middle || "",
        last: data.name?.last || ""
      },
      imageUrl: data.imageUrl || "",
      gender: data.gender || "",
      ethenic: data.ethenic || "",
      email: data.email || "",
      password: data.password || "",
      mobileNumber: data.mobileNumber || "",
      devices: Array.isArray(data.devices) ? data.devices : [],
      dateOfBirth: data.dateOfBirth || "",

      address: {
        street: data.address?.street || "",
        city: data.address?.city || "",
        state: data.address?.state || "",
        country: data.address?.country || "",
        postalCode: data.address?.postalCode || ""
      },

      consent: {
        accepted: data.consent?.accepted ?? false,
        date: data.consent?.date || ""
      },

      payAccounts: {
        accountId: data.payAccounts?.accountId || "",
        provider: data.payAccounts?.provider || "",
        linkedOn: data.payAccounts?.linkedOn || ""
      },

      profiles: Array.isArray(data.profiles) ? data.profiles : [],
      nProfCount: data.nProfCount || 0,
      nBlogs: data.nBlogs || 0,
      blogs: Array.isArray(data.blogs) ? data.blogs : [],
      nAudios: data.nAudios || 0,
      audios: Array.isArray(data.audios) ? data.audios : [],
      nVideos: data.nVideos || 0,
      videos: Array.isArray(data.videos) ? data.videos : [],
      nImages: data.nImages || 0,
      images: Array.isArray(data.images) ? data.images : [],
      nReels: data.nReels || 0,
      reels: Array.isArray(data.reels) ? data.reels : [],

      connections: {
        friendCount: data.connections?.friendCount || 0,
        admirerCount: data.connections?.admirerCount || 0,
        admireeCount: data.connections?.admireeCount || 0,
        collaborateCount: data.connections?.collaborateCount || 0,
        groupsCount: data.connections?.groupsCount || 0,

        admirers: Array.isArray(data.connections?.admirers)
          ? data.connections.admirers.map((admirer) => ({
              userName: admirer.userName || "",
              userId: admirer.userId || "", // <- FIXED here
              imageUrl: admirer.imageUrl || "",
              createdOn: admirer.createdOn || "",
              pastAbuse: admirer.pastAbuse ?? false,
              canMessage: admirer.canMessage ?? false,
              canAudio: admirer.canAudio ?? false,
              canVideo: admirer.canVideo ?? false,
            }))
          : [],

        friends: Array.isArray(data.connections?.friends)
          ? data.connections.friends
          : [],

        collaborator: Array.isArray(data.connections?.collaborator)
          ? data.connections.collaborator
          : [],

        groups: Array.isArray(data.connections?.groups)
          ? data.connections.groups
          : [],
      }
    };

    return formattedData;
  } catch (error) {
    console.error("Failed to fetch user mock data:", error.message);
    return null;
  }
};
